import React from 'react';
import PropTypes from 'prop-types';

import Banner from '../components/distributors/Banner';
import Information from '../components/distributors/Information';
import Footer from '../components/footer/Footer';
import AnimatedPage from '../components/ui-elements/AnimatedPage';
import Section from '../components/ui-elements/Section';

function Distributor({ distributor, displayOnlyLogoOnBanner = false }) {
    const { logo, title, locations, webPage } = distributor;

    return (
        <AnimatedPage className={'min-h-screen'}>
            <Section>
                <Banner
                    logo={logo}
                    title={title}
                    displayOnlyLogo={displayOnlyLogoOnBanner}
                />
            </Section>

            <Section classStyle={'bg-indotech-primary_blue'}>
                <Information
                    locations={locations}
                    webPage={webPage}
                />
            </Section>

            <Footer />
        </AnimatedPage>
    );
}

Distributor.propTypes = {
    distributor: PropTypes.object,
};

Distributor.defaultProps = {
    distributor: {
        key: '',
        logo: '',
        title: {
            fullName: '',
            firstPart: '',
            highlightedPart: '',
        },
        linkTo: '',
        description: '',
        locations: [],
        webPage: '',
    },
};

export default Distributor;
